import * as React from "react";

function SvgUserlike(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="123.086 248.414 82 75"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#00ADEF"
        d="M126.09 249.352c2.848 4.137 5.34 7.25 7.473 9.34 3.695 3.699 7.188 5.539 10.477 5.539.938 0 1.695-.223 2.27-.664.539-.492.801-1.176.801-2.07 0-.441-.055-.996-.164-1.668-.113-.668-.168-1.137-.168-1.402 0-2.707.957-5.063 2.867-7.039 1.914-1.984 4.5-2.973 7.742-2.973 3.426 0 6.207 1.039 8.344 3.105 2.133 2.07 3.203 4.773 3.203 8.109 0 4.09-1.434 7.441-4.309 10.047-2.867 2.598-6.703 3.902-11.508 3.902-7.34 0-14.016-2.938-20.02-8.813-3.203-3.199-6.543-7.805-10.012-13.813l3.004-1.6z"
      />
      <path
        fill="#393536"
        d="M188.852 260.008v36.914c0 6.234-.688 8.629-1.969 10.508-3.418 5.297-9.828 5.383-11.961 5.383-12.902 0-13.418-8.457-13.418-15.207v-16.844c-2.121 1.375-4.75 2.078-7.898 2.078-1.836 0-3.613-.254-5.344-.707v14.789c0 5.723.168 10.508 3.16 15.207 5.813 9.316 17.09 10.684 23.242 10.684 12.477 0 27.086-5.898 27.086-24.27v-38.535h-12.898z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgUserlike);
